import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Table, Actions, Params } from 'nallian-table-builder-ui';
import { INFINITE_SCROLL, JOIN_REQUESTS_RESOURCE, COMMUNITY_TAB_ACTIONS } from '../../constants';
import JoinRequestDetail from './JoinRequestDetail';
import AcceptJoinRequest from './AcceptJoinRequest';
import JoinRequestStatus from './JoinRequestStatus';
import PotentialDuplicateFilter from './PotentialDuplicateFilter';
import apiRoutes from '../../../../app/api/routes';

const convertFilters = ({ isPotentialDuplicate, ...filters }) => ({
  ...filters,
  isPotentialDuplicate:
    isPotentialDuplicate === 1 ? true : isPotentialDuplicate === 0 ? false : isPotentialDuplicate,
});

const FILTER_SETTINGS = {
  defaults: {},
  convertor: convertFilters,
};

const JoinRequestsOverview = ({ communityId, rootUrl, isCommunityView }) => {
  const { id: paramsId, action, actionId } = useParams();

  const id = communityId || paramsId;

  return (
    <>
      <JoinRequestDetail
        open={id && action === COMMUNITY_TAB_ACTIONS.EDIT_JOIN_REQUEST && actionId}
        communityId={id}
        rootUrl={rootUrl}
      />
      <AcceptJoinRequest
        open={id && action === COMMUNITY_TAB_ACTIONS.ACCEPT_JOIN_REQUEST && actionId}
        communityId={id}
        rootUrl={rootUrl}
        isCommunityView={isCommunityView}
      />
      <Table
        url={apiRoutes.v3JoinRequestsOverview(id)}
        infiniteScroll={INFINITE_SCROLL}
        resource={JOIN_REQUESTS_RESOURCE}
        filtered={FILTER_SETTINGS}
        pageSize={100}
        noUserSettings
      >
        <Actions.Link
          width="2.5rem"
          align="center"
          icon="eye"
          url={`${rootUrl}/${COMMUNITY_TAB_ACTIONS.EDIT_JOIN_REQUEST}/:id`}
        />
        <Params.String grow name="fullName" width="16rem" minWidth="16rem" />
        <Params.String grow name="emailAddress" width="16rem" minWidth="16rem" />
        <Params.String grow name="organisationName" width="16rem" minWidth="16rem" />
        <Params.DateTime
          name="createdOn"
          label="requestedAt"
          width="9rem"
          minWidth="9rem"
          grow
          noFilter
        />
        <Params.Custom
          content={JoinRequestStatus}
          filter={PotentialDuplicateFilter}
          name="isPotentialDuplicate"
          label="status"
          width="12rem"
          minWidth="12rem"
          noSort
        />
      </Table>
    </>
  );
};

JoinRequestsOverview.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  communityId: PropTypes.string,
  isCommunityView: PropTypes.bool,
};

JoinRequestsOverview.defaultProps = { communityId: undefined, isCommunityView: false };

export default JoinRequestsOverview;
